export type CalibrationAreaFormValues = {
  id: string
  x: number
  y: number
  width: number
  height: number
}

export const CALIBRATION_AREA_FORM_DEFAULT_VALUES: CalibrationAreaFormValues = {
  id: '',
  x: 0,
  y: 0,
  width: 0,
  height: 0,
}
